import {swapClassesViaBool} from '../selectorHelpers';


export function flipArrowIcon(dir, icon){
  swapClassesViaBool(icon, "fa-angle-down", "fa-angle-up", (dir === "down"));
}


// WEBPACK FOOTER //
// ./src/utilities/fontAwesomeHelpers/index.js